import { render, staticRenderFns } from "./FooterRating.vue?vue&type=template&id=62e8232e&scoped=true&"
import script from "./FooterRating.vue?vue&type=script&lang=ts&"
export * from "./FooterRating.vue?vue&type=script&lang=ts&"
import style0 from "./FooterRating.vue?vue&type=style&index=0&id=62e8232e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e8232e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsTextLink: require('/var/www/packages/theme/components/atoms/TextLink.vue').default})
